import React, {PureComponent} from "react";
import italianResetTranslations from "../../translations/reset/it.reset.json";
import englishResetTranslations from "../../translations/reset/en.reset.json";
import {Translate, withLocalize} from "react-localize-redux";
import {
    Button,
    Card,
    CardBody, CardHeader,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText, Row
} from "reactstrap";
import {connect} from "react-redux";
import Header from "../../components/Headers/Header";
import * as actions from "../../store/actions/actions";

class Reset extends PureComponent {
    constructor(props) {
        super(props);

        this.props.addTranslationForLanguage(italianResetTranslations, "it");
        this.props.addTranslationForLanguage(englishResetTranslations, "en");
    }
    submitHandler = (event) => {
        event.preventDefault();
        let newPassword = event.target.password.value;
        let newPasswordConfirmation = event.target.confirmpassword.value;
        let username=this.props.username;
        const data = {newPassword:newPassword, newPasswordConfirmation:newPasswordConfirmation,username:username};
        this.props.updatePassword(data)
    }
    render() {

        let errors="";
        errors=this.props.validationError;
        /*let upperCaseError=false;
        let lowerCaseError=false;
        let notMatching=false;
        let specialCharError=false;
        let numberError=false;
        let lenght=false;*/
        let hasErrors=false;
        let passwordError=[]
        let passwordErrorCount=0;
        if(errors !== null && errors !== "" && errors !== undefined){
            if(errors.data.length>0){
                errors.data.map((item) =>{
                    if(item.field === 'newPassword'){
                        if(passwordErrorCount === 0){
                            passwordError.push(item.defaultMessage)
                            // passwordError=item.defaultMessage;
                            passwordErrorCount+=1
                            hasErrors=true
                        }else if(passwordErrorCount > 0){
                            passwordError.push(item.defaultMessage)
                            hasErrors=true
                            // passwordError=passwordError+ " \n " +item.defaultMessage
                            passwordErrorCount+=1;
                        }
                    }
                    return ""
                })
            }
        }
        return (
            <>
                <Header />
                <Container className="mt--5" fluid>
                    <Row>
                        <div className="col">
                            <Card className="shadow">
                                <CardHeader className="border-0">
                                    <Row>
                                        <div className="col">
                                            <h3 className="mb-0">
                                                <Translate id="reset.password.title"/>
                                            </h3>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <CardBody className="px-lg-5 py-lg-5">
                                    <div className="text-center text-muted mb-4">
                                        <small>
                                            <Translate id="reset.password.subheading"/>
                                        </small>
                                    </div>
                                    <div className={hasErrors === true ? "text-center text-muted mb-4" : "noErrors"}>
                                        <small className={hasErrors === true ? "highlight":""}>
                                            { passwordError.length > 0 ? <label style={{color:"red"}}>

                                                {passwordError.map((item)=>{
                                                    return <span>
                                                            <Translate id=
                                                                           {item}
                                                            />
                                                            <br></br>
                                                          </span>
                                                })}

                                            </label> : "" }

                                        </small>
                                    </div>
                                    <Form role="form" onSubmit={this.submitHandler}>
                                        <input type="hidden" value="nothing"/>
                                        <FormGroup className="mb-3">
                                            <InputGroup className="input-group-alternative">
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="ni ni-lock-circle-open" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Translate>
                                                    {({ translate }) =>
                                                        <Input id="password"
                                                               label={translate("reset.password")}
                                                               placeholder={translate("reset.password")}
                                                               type="text"
                                                               autoComplete="off"
                                                               />
                                                    }
                                                </Translate>
                                            </InputGroup>
                                        </FormGroup>
                                        <FormGroup>
                                            <InputGroup className="input-group-alternative">
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="ni ni-lock-circle-open" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Translate>
                                                    {({ translate }) =>
                                                        <Input id="confirmpassword"
                                                               label={translate("reset.confirm.password")}
                                                               variant="outlined"
                                                               placeholder={translate("reset.confirm.password")}
                                                               type="password"
                                                               autoComplete="new-password"
                                                        />
                                                    }
                                                </Translate>
                                            </InputGroup>
                                        </FormGroup>

                                        <div className="text-center">
                                            <Button className="my-4" type="submit" variant="contained" color="primary">
                                                <Translate id="reset.password.confirm.button"/>
                                            </Button>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

}
const mapStateToProps = state => {
    return {
        validationError:state.password.error,
        username: state.authentication.authenticatedUser.username,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updatePassword: (cred) => dispatch({ type: actions.CHANGE_RESET_PASSWORD_REQUEST, value: cred }),
    }
}
export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Reset));